import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import FloorMapLayer from "./FloorMapLayer";


const FloorMapPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Floor Maps" />

        {/* FloorMapLayer */}
        <FloorMapLayer />
      </MasterLayout>
    </>
  );
};

export default FloorMapPage;
